let mainPath = "/jobs";
let viewFolder = "Job";

module.exports = [
    {
        path: mainPath,
        name: 'jobs',
        component: () => import(/* webpackChunkName: "Warehouse" */ '../views/'+viewFolder+'/Index.vue'),
        // beforeEnter: (to, from, next) => {
        //   if (!localStorage.getItem('userId')) next({ name: 'Home' })
        //   else next()
        // }
    }
]